import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, finalize, throwError } from 'rxjs';

import { AuthService, FeedMessageService, LoadingService, SigntrustService, UserPinSessionService, UtilsService } from '@services/index.service';
import { AngularPaths, CheckDomainRequest, Consumer, ErrorCode, MessageType, Response } from '@models/index.model';
import { TranslateService } from '@ngx-translate/core';

@Injectable({providedIn: 'root'})
export class UserPinRouteGuard {
  public constructor(
    private _userPinSession: UserPinSessionService,
    private _router: Router,
    public _utils: UtilsService,
    private _loading: LoadingService,
    public _auth: AuthService,
    public translate: TranslateService,
    private _signtrustServ: SigntrustService,
    private _notify: FeedMessageService
    ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const userPinRedirectId = localStorage.getItem('userPinRedirectId');
    if (this._userPinSession.checkTokenValid()) {
      if (state.url.includes(`/${AngularPaths.CONFIG_USER_PIN}`) && userPinRedirectId) {
        return this._router.parseUrl(`${AngularPaths.CONFIG_USER_PIN}/${userPinRedirectId}`);
      }
    } else if (state.url.includes(`/${AngularPaths.CONFIG_USER_PIN}`) && userPinRedirectId) {
      return this._router.parseUrl(`${AngularPaths.USER_PIN}/${userPinRedirectId}`);
    } else if (state.url.includes(`/${AngularPaths.USER_PIN}`) && userPinRedirectId) {
      return this._router.parseUrl(`${AngularPaths.USER_PIN}/${userPinRedirectId}`);
    } else {
      this._userPinSession.removeBrowserSession();
      return this._router.parseUrl(`${AngularPaths.DEFAULT}`);

    }
  }
}
